import styled, { css } from 'styled-components';
import { SelectVariant, SelectSize } from './types';

const variantStyles = {
  default: css`
    border-color: ${({ theme }) => theme.colors.gray300};
    
    &:focus {
      border-color: ${({ theme }) => theme.colors.primary};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}20;
    }
  `,
  error: css`
    border-color: ${({ theme }) => theme.colors.danger};
    
    &:focus {
      border-color: ${({ theme }) => theme.colors.danger};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.danger}20;
    }
  `,
  success: css`
    border-color: ${({ theme }) => theme.colors.success || '#10b981'};
    
    &:focus {
      border-color: ${({ theme }) => theme.colors.success || '#10b981'};
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.success || '#10b981'}20;
    }
  `,
};

const sizeStyles = {
  default: css`
    padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[4]}`};
    font-size: ${({ theme }) => theme.typography.fontSize.sm};
  `,
  sm: css`
    padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[3]}`};
    font-size: ${({ theme }) => theme.typography.fontSize.xs};
  `,
  lg: css`
    padding: ${({ theme }) => `${theme.spacing[4]} ${theme.spacing[5]}`};
    font-size: ${({ theme }) => theme.typography.fontSize.md};
  `,
};

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  display: block;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.gray700};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
`;

export const StyledSelect = styled.select<{ $variant: SelectVariant; $size: SelectSize }>`
  width: 100%;
  border: 1px solid;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  color: ${({ theme }) => theme.colors.gray800};
  background-color: white;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.gray100};
    cursor: not-allowed;
    opacity: 0.6;
  }

  /* Style for placeholder option */
  option[value=""][disabled] {
    color: ${({ theme }) => theme.colors.gray400};
  }

  ${({ $variant }) => variantStyles[$variant]}
  ${({ $size }) => sizeStyles[$size]}
`;

export const ErrorMessage = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.danger};
  margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const HelperText = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.gray500};
  margin-top: ${({ theme }) => theme.spacing[1]};
`;
